module.exports = __webpack_public_path__ + "static/media/gallery02.2dd1c336.png";